import React, { useContext, useEffect, useRef } from "react";

import {
  ComparisonHeader,
  ComparisonTable,
  CameraComparisonContext
} from "../../camera-comparison";

import { useCameraComparison } from "../useCameraComparison";
import { generateClassString as gcs } from "../../../../lib/helper/generateClassString";

import * as styles from "./cameraComparison.module.less";
import CameraFilterContext from "../../CameraListing/CameraFilterContext";
import { InquiryButton } from "../../../../components/InquiryButton/InquiryButton";
import { Button } from "../../../../components/Button";
import { useOnScreen } from "../../../../lib/hooks/useOnScreen";
import t from "../../../../lib/translate";

export function CameraComparison({ config }) {
  const { allItems } = useContext(CameraFilterContext);
  const { active, hidden, slideState } = useContext(CameraComparisonContext);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    console.log(slideState);
  }, [slideState]);
  return (
    <div
      className={gcs(
        styles.cameraComparisonWrapper,
        [active, styles.active],
        [slideState === "down", styles.slideDown],
        [slideState === "hide", styles.hideWrapper],
        [slideState === "show", styles.showWrapper]
      )}
    >
      <div
        className={gcs(styles.fixedOverlay, [
          !hidden && slideState !== "hide",
          styles.show
        ])}
      >
        <Button
          aria-label={t("navigation.button.to.top")}
          onClick={scrollToTop}
          className={styles.backToTopBtn}
          type="prev"
          icon="arrowLeft"
        />

        <InquiryButton config={config} />
      </div>
      <div className={styles.cameraComparisonContainer}>
        <ComparisonHeader />
        {active && <ComparisonTable />}
      </div>
    </div>
  );
}
